import React from 'react';
import useMetaTags from '../hooks/useMetaTags';
import '../styles/PrivacyPolicy.css';

const PrivacyPolicy = () => {
  useMetaTags({
    title: 'Privacy Policy | Sam Penny',
    description: 'Privacy Policy for sampenny.io - Learn how we handle and protect your data.',
  });

  return (
    <div className="privacy-policy-page">
      <div className="privacy-policy-container">
        <h1>Privacy Policy</h1>
        <div className="privacy-content">
          <section>
            <h2>Introduction</h2>
            <p>This privacy policy explains how sampenny.io ("we", "us", or "our") collects, uses, and protects your personal information.</p>
          </section>

          <section>
            <h2>Information We Collect</h2>
            <p>We collect information that you provide directly to us when you:</p>
            <ul>
              <li>Contact us through our website</li>
              <li>Subscribe to our newsletter</li>
              <li>Leave comments on our blog</li>
            </ul>
          </section>

          <section>
            <h2>How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Respond to your inquiries</li>
              <li>Send you updates and marketing communications (with your consent)</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>Contact</h2>
            <p>If you have any questions about this privacy policy, please contact us at:</p>
            <p>&#115;&#97;&#109;&#64;&#115;&#97;&#109;&#112;&#101;&#110;&#110;&#121;&#46;&#105;&#111;</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 